<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="columns onboarding-create-site__step8">
    <div
      class="column is-5 onboarding-create-site__img onboarding-create-site__img--step8 is-hidden-mobile"
      :style="`background-image: url(${imgNoivos})`"
    ></div>
    <div
      class="column has-text-centered onboarding-create-site__description onboarding-create-site__description--step8"
    >
      <div class="onboarding-create-site__description--width-80">
        <h1 class="onboarding-create-site__title has-text-weight-bold">
          Escolha um link para seu site
        </h1>
        <p class="onboarding-create-site__paragraph">
          Esse será o link que vocês compartilharão com seus convidados
        </p>
        <div class="onboarding-create-site__form-validate-url">
          <form class="margin-bottom">
            <div class="onboarding-create-site__form-validate-url--flex">
              <p class="onboarding-create-site__step8--paragraph">
                noivos.casar.com/
              </p>

              <div class="field-body">
                <div class="field">
                  <div class="control" autocomplete="off">
                    <input
                      ref="FocusOnError"
                      v-model="urlWeddingSite"
                      :class="{ 'has-value': urlWeddingSite }"
                      name="urlWeddingSite"
                      class="input"
                      style="color: $gray-6"
                      type="text"
                      v-debounce:1s="getUrlWedSite"
                      :debounce-events="'keyup'"
                    />
                    <label for="urlWeddingSite" class="label"
                      >Digite o endereço do seu site</label
                    >
                  </div>
                  <p
                    v-if="urlWeddingSite"
                    class="onboarding-create-site__step8--paragraph onboarding-create-site__step8--message"
                    :class="`message--${this.class}`"
                  >
                    {{ message }}
                  </p>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <buttonsNext
        :stepNumber="stepNumber"
        :urlWedding="urlWeddingChange"
        :steps="answerSteps"
      />
    </div>
  </div>
</template>

<script>
import verifyOnboardingCompleteMixin from '@/mixins/verifyOnboardingCompleteMixin'
import buttonsNext from '@/components/OnboardingCreationSite/ButtonsNext.vue'
import imgNoivos from '@/assets/img/onboarding-create-site/noivos.jpg'

import Onboarding from '@/lib/api/Onboarding.js'

export default {
  mixins: [verifyOnboardingCompleteMixin],

  components: {
    buttonsNext,
  },

  props: {
    stepNumber: Number,
  },

  computed: {
    logonToken() {
      return this.$store.state.app.logonToken
    },

    answerUser: {
      get() {
        return this.$store.state.onboardingCreateSite.answersOfStep
      },
      set(payload) {
        this.$store.dispatch('setAnswer', payload)
      },
    },

    step: {
      get() {
        return this.$store.state.onboardingCreateSite.step
      },
      set(payload) {
        this.$store.dispatch('setStep', payload)
      },
    },
  },

  data() {
    return {
      imgNoivos,
      urlWeddingSite: '',
      message: '',
      class: '',
      urlWeddingChange: '',
      answerSteps: {},
    }
  },

  mounted() {
    this.step = true
    this.urlWeddingSite = this.answerUser.step8
  },

  methods: {
    getStepNumber() {
      const stepNumber = this.$route.params.id.split('-')
      return parseInt(stepNumber[1])
    },

    async getUrlWedSite() {
      const onboarding = new Onboarding(this.logonToken)
      const result = await onboarding
        .getUrlAvailable(this.urlWeddingSite)
        // eslint-disable-next-line prettier/prettier
        .then((response) => {
          return response
        })
        // eslint-disable-next-line prettier/prettier
        .catch((err) => {
          return err
        })

      if (!result.data) {
        this.class = 'error'
        this.step = false
        this.message = result.error.message
      } else {
        this.class = 'available'
        this.message = 'O endereço escolhido está disponível'
        this.answerUser.step8 = result.data.clean_url
        this.urlWeddingChange = this.answerUser.step8
        this.step = true
      }
    },
  },
}
</script>

<style lang="scss">
.onboarding-create-site {
  &__step8 {
    display: flex;
    min-height: fit-content;

    .field-body {
      position: relative;
      padding-left: 3px;
    }

    .focus-visible {
      border-color: #4aafb0;
    }

    input {
      border-bottom: 1px solid $gray-4;
      border-radius: 0;
    }

    .label {
      color: $gray-6 !important;
    }

    .control {
      &:focus-visible {
        label {
          color: red;
        }
      }
    }

    &--message {
      position: absolute;
    }
  }

  &__img {
    &--step8 {
      margin-top: 12px;
    }
  }

  &__description {
    &--step8 {
      min-height: calc(100vh - 56px);
    }
  }

  &__form-validate-url {
    padding: 10px 20px 30px;

    @media (min-width: $tablet) {
      padding: 30px 20px;
    }

    &--flex {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}

.message--error {
  text-align: left;
  color: $errordark;
  font-size: 14px;
}

.message--available {
  text-align: left;
  color: #4aafb0;
  font-size: 14px;
}
</style>
